import React from 'react'

import './ItemList.css'
import { ItemDetail, PageProperties } from '../types'

const getItemList = (items: Array<ItemDetail>) => (
  <div className="thin">
    {
      items?.map((proj, i) => {
        const imageDiv = (<div className="project-img has-text-centered  is-flex-direction-column is-align-items-center is-align-self-center">
          <div className="is-size-7 is-align-items-center is-align-self-center">{proj.image?.legend}</div>
          <img
            className="project-img-file"
            width={proj.image?.width ? proj.image.width : "600"}
            alt={proj.title}
            src={require(`../site/images/${proj.image?.uri}`)}
            onClick={() => window.open(proj.image?.link)}
            onKeyPress={() => window.open(proj.image?.link)}
          />
        </div>)

        const descriptionDiv = (<div className="project-desc">
          <div className="forceWhite is-size-4 is-italic">
            {proj.description}
          </div>
        </div>)

        return (
          <div className={`project ${i % 2 === 0 ? 'project-even' : 'project-odd'}`} key={proj.title}>
            <div className="project-image-wrapper">
              <div style={proj.title === "playlistmigrator" ? { paddingBottom: 48 } : proj.title === "preservemontana" || proj.title === "fiduciary" ? { maxWidth: 300 } : {}}>{imageDiv}</div>
            </div>
            <div className="project-desc-wrapper">
              {descriptionDiv}
            </div>
            {i % 2 === 0 && <hr className="bigHR" />}
          </div>
        )
      })
    }
  </div>
)

const ItemList = ({ page }: PageProperties) => {
  return (
    <div className="view force-full-view portfolio-container"
      style={{
        paddingTop: '8rem',
        background: `linear-gradient(${page.gradient?.direction}, ${page.gradient?.first}, ${page.gradient?.second})`
      }}>
      <div className="title forceWhite">
        {page.title}
      </div>
      <div className="subtitle forceWhite">
        {page.subtitle}
      </div>
      <hr />
      {page.content.items && getItemList(page.content.items)}
    </div>
  )
}

export default ItemList